import React from 'react';

const Divider = () => (
  <div className="divider">
    <span>or</span>
  </div>
);

export default Divider;